import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import "primereact/resources/themes/lara-light-teal/theme.css";    //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
import { PrimeReactProvider } from 'primereact/api';
//icons
import "/node_modules/primeflex/primeflex.css";
import './index.css';

import {HashRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./system/store";
// import './theme.css';
import "material-symbols/rounded.css";

import '@fortawesome/fontawesome-free/css/all.min.css';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <HashRouter>
        <Provider store={store}>
            {/*<React.StrictMode>*/}
            {/*    <App />*/}
            {/*</React.StrictMode>*/}
            <App />
        </Provider>
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
